import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "desktop_nav" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "navigation" }
const _hoisted_4 = { class: "nav_list" }
const _hoisted_5 = { class: "mobile_navigation" }
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 0,
  id: "mobile_nav_list"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "name_header",
        title: "Link zur Startseite",
        onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.activeNav = '99';})
      }, {
        default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
          _createTextVNode("Anika Wagner", -1)
        ]))]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/",
        class: "logo_header",
        title: "Startseite",
        onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.activeNav = '99';})
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: require('@/assets/' + _ctx.awImgSrc),
            alt: "AW in gemalten Farben"
          }, null, 8, _hoisted_2)
        ]),
        _: 1
      }),
      _createElementVNode("nav", _hoisted_3, [
        _createElementVNode("ul", _hoisted_4, [
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: "/galerie",
              class: _normalizeClass({'nav_link':true, 'active':(_ctx.activeNav.value === '0')}),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.activeNav = '0'))
            }, {
              default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                _createTextVNode("Galerie", -1)
              ]))]),
              _: 1
            }, 8, ["class"])
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: "/ueberMich",
              class: _normalizeClass({'nav_link':true, 'active':(_ctx.activeNav.value === '1')}),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.activeNav = '1'))
            }, {
              default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                _createTextVNode("Über mich", -1)
              ]))]),
              _: 1
            }, 8, ["class"])
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: "/kontakt",
              class: _normalizeClass({'nav_link':true, 'active':(_ctx.activeNav.value === '2')}),
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.activeNav = '2'))
            }, {
              default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                _createTextVNode("Kontakt", -1)
              ]))]),
              _: 1
            }, 8, ["class"])
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: "/impressum",
              class: _normalizeClass({'nav_link':true, 'active':(_ctx.activeNav.value === '3')}),
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.activeNav = '3'))
            }, {
              default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                _createTextVNode("Impressum", -1)
              ]))]),
              _: 1
            }, 8, ["class"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("a", {
        href: "./index.html",
        class: "name_header",
        title: "Link zur Startseite",
        onClick: _cache[6] || (_cache[6] = ($event: any) => {_ctx.activeNav = '99';})
      }, "Anika Wagner"),
      _createElementVNode("a", {
        href: "./index.html",
        class: "logo_header",
        title: "Startseite",
        onClick: _cache[7] || (_cache[7] = ($event: any) => {_ctx.activeNav = '99';})
      }, [
        _createElementVNode("img", {
          src: require('@/assets/' + _ctx.awImgSrc),
          alt: "AW in gemalten Farben"
        }, null, 8, _hoisted_6)
      ]),
      _createElementVNode("nav", null, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          id: "hamburg",
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.showMobileNav) = $event)),
          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.toggleShowMobileNav()))
        }, null, 512), [
          [_vModelCheckbox, _ctx.showMobileNav]
        ]),
        _cache[19] || (_cache[19] = _createElementVNode("label", {
          for: "hamburg",
          class: "hamburg"
        }, [
          _createElementVNode("span", { class: "line" }),
          _createElementVNode("span", { class: "line" }),
          _createElementVNode("span", { class: "line" })
        ], -1))
      ])
    ]),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.showMobileNav)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  to: "/galerie",
                  class: _normalizeClass({'nav_link':true, 'active':(_ctx.activeNav.value === '0')}),
                  onClick: _cache[10] || (_cache[10] = ($event: any) => {_ctx.toggleShowMobileNav(); _ctx.activeNav = '0';})
                }, {
                  default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                    _createTextVNode("Galerie", -1)
                  ]))]),
                  _: 1
                }, 8, ["class"])
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  to: "/ueberMich",
                  class: _normalizeClass({'nav_link':true, 'active':(_ctx.activeNav.value === '1')}),
                  onClick: _cache[11] || (_cache[11] = ($event: any) => {_ctx.toggleShowMobileNav(); _ctx.activeNav = '1';})
                }, {
                  default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                    _createTextVNode("Über mich", -1)
                  ]))]),
                  _: 1
                }, 8, ["class"])
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  to: "/kontakt",
                  class: _normalizeClass({'nav_link':true, 'active':(_ctx.activeNav.value === '2')}),
                  onClick: _cache[12] || (_cache[12] = ($event: any) => {_ctx.toggleShowMobileNav(); _ctx.activeNav = '2';})
                }, {
                  default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                    _createTextVNode("Kontakt", -1)
                  ]))]),
                  _: 1
                }, 8, ["class"])
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  to: "/impressum",
                  class: _normalizeClass({'nav_link':true, 'active':(_ctx.activeNav.value === '3')}),
                  onClick: _cache[13] || (_cache[13] = ($event: any) => {_ctx.toggleShowMobileNav(); _ctx.activeNav = '3';})
                }, {
                  default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                    _createTextVNode("Impressum", -1)
                  ]))]),
                  _: 1
                }, 8, ["class"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}